import React from 'react';
import { useI18n } from '../../i18n/index.jsx';
import Icon from '../../components/Icon.jsx';

// Company profile review state, shown on Company details and Contact details.
export default function ReviewNotice({ review }) {
  const { t } = useI18n();
  if (review.status === 'pending') return <div className="acc-lock" role="status"><Icon name="lock" size={20} /><span>{t('company.underReview')}</span></div>;
  if (review.status === 'rejected') {
    return (
      <div className="review-banner review-rejected" role="alert">
        <strong>{t('company.rejectedTitle')}</strong> {review.reason}
        <div className="small">{t('company.rejectedHelp')}</div>
      </div>
    );
  }
  if (review.status === 'changes_requested') {
    return (
      <div className="review-banner review-requested" role="alert">
        <strong>{t('company.requestedTitle')}</strong> {review.reason}
        <div className="small">{t('company.requestedHelp')}</div>
      </div>
    );
  }
  // Approved: shown for a week after the decision.
  if (review.status === 'approved' && review.reviewedAt && Date.now() - new Date(review.reviewedAt).getTime() < 7 * 864e5) {
    return <div className="review-banner review-approved" role="status"><strong>{t('company.approvedTitle')}</strong> {t('company.approvedHelp')}</div>;
  }
  return null;
}
